import type { FileRecordContentKind } from "@/panes/file-record-detail/contentType";

/** Export format ids for file-record download variants. */
export type FileExportKind =
  | "html"
  | "pdf"
  | "markdown"
  | "docx"
  | "text"
  | "original";

export type FileRecordExportVariantDefinition = {
  format: FileExportKind;
  label: string;
};

/** Labels for each export format — single source of truth for all surfaces. */
export const FILE_EXPORT_FORMAT_CATALOG: Record<
  FileExportKind,
  { label: string }
> = {
  html: { label: "HTML" },
  pdf: { label: "PDF" },
  markdown: { label: "Markdown" },
  docx: { label: "Microsoft Word (.docx)" },
  text: { label: "Plain text (.txt)" },
  original: { label: "Original file" },
};

/**
 * Which export formats are offered per content kind. Surfaces expand the
 * registry `download` action into these variants at runtime.
 */
export const FILE_EXPORT_VARIANTS_BY_CONTENT_KIND: Record<
  FileRecordContentKind,
  readonly FileExportKind[]
> = {
  image: ["original"],
  pdf: ["original"],
  video: ["original"],
  audio: ["original"],
  office: ["original"],
  spreadsheet: ["original"],
  fallback: ["original"],
  markdown: ["html", "pdf", "markdown", "docx"],
  html: ["html", "pdf", "markdown", "docx"],
  text: ["text", "pdf"],
};

export function exportVariantsForContentKind(
  kind: FileRecordContentKind,
): FileRecordExportVariantDefinition[] {
  const formats = FILE_EXPORT_VARIANTS_BY_CONTENT_KIND[kind] ?? ["original"];
  return formats.map((format) => ({
    format,
    label: FILE_EXPORT_FORMAT_CATALOG[format].label,
  }));
}
